var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.mergedInitialValues}}),_c('VBtn',{attrs:{"elevation":"2","fab":"","x-small":""}},[_c('VIcon',{attrs:{"small":""},on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v("mdi-close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }